import { lazy } from "react";

export const ManageUserDetailsAsync = lazy(() => import("./ManageUserDetails"));
